module.exports = __webpack_public_path__ + "media/dotsdetail.758238c4.mp4";